import { Typography, useTheme } from '@material-ui/core';
import React from 'react';
import { useTranslate } from 'react-admin';

import type { Place } from '../types/warehouse.types';
import { StorageEntityInfo } from '../types/warehouse.types';
import { groupByStack } from '../utils/stackHelpers';
import { PlaceInformationContent } from './PlaceInformationContent';
import { SinglePalletInfo } from './SinglePalletInfo';

interface PlaceDetailsContentProps {
  place: Place;
  storageEntities: StorageEntityInfo[];
  showButtons?: boolean;
}

export const PlaceDetailsContent: React.FC<PlaceDetailsContentProps> = ({ place, storageEntities, showButtons = false }) => {
  const theme = useTheme();
  const translate = useTranslate();

  const entityGroups = groupByStack(storageEntities);

  return (
    <>
      {/* Pallet Information */}
      {entityGroups.map((group, groupIndex) => (
        <div
          key={group[0].pallet_sscc || groupIndex}
          style={{
            marginBottom: entityGroups.length > 1 ? '15px' : '0',
            ...(group.length > 1 && {
              border: `1px solid ${theme.palette.primary.main}`,
              borderRadius: '4px',
              padding: '0 8px 8px',
            }),
          }}
        >
          {group.length > 1 && (
            <Typography
              component="p"
              variant="subtitle2"
              style={{ margin: '8px 0 0', fontWeight: 'bold', color: theme.palette.primary.main }}
            >
              {translate('osfc.storage_ui.pallet_info.stacked_records', { count: group.length })}
            </Typography>
          )}
          {group.map((storageEntity, index) => (
            <div key={storageEntity.pallet_sscc || index}>
              <SinglePalletInfo storageEntity={storageEntity} />
            </div>
          ))}
        </div>
      ))}

      {/* Place Information*/}
      <div style={{ 
        marginTop: storageEntities.length > 0 ? '15px' : '0', 
        paddingTop: storageEntities.length > 0 ? '15px' : '0', 
        borderTop: storageEntities.length > 0 ? `1px solid ${theme.palette.divider}` : 'none' 
      }}>
        <Typography
          component="p"
          variant="subtitle2"
          style={{ margin: 0, fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}
        >
          {translate('osfc.storage_ui.place_details.title')}
        </Typography>
        <PlaceInformationContent place={place} />
      </div>
    </>
  );
};
